import * as React from 'react';
import './Home.scss';
import { connect, useSelector, useDispatch } from 'react-redux';
import CustomDayCalendar, { CalendarSchedule } from '../../../components/CustomDayCalendar';
import { getProfessionalAvailabilitySchedules, AvailabilityProfessional } from '../../../shared/appointmint/professionalAvailability';
import TitledContainer from '../../../components/TitledContainer';
import { useTranslations, Translate } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { AppointmentChangeReason, AppointmentData, ClientRequestType, CommunicationType, DayOfWeekEnum, HomeCalendarPreferencesData, PaymentOrigin, ProfessionalData } from '../../../models';
import { parseTimeStringToMinutes, addDayToDateString, getWeekDayTranslationKey, minutesToTimeString, getDateString } from '../../../shared/utils';
import { AutocompleteTextField, DateField, ComboField, ComboFieldOption } from '../../../components/Forms/fields';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import EventIcon from '@material-ui/icons/Event';
import DateRangeIcon from '@material-ui/icons/DateRange';
import WorkIcon from '@material-ui/icons/Work';
import DoorFrontIcon from '@material-ui/icons/Room'
import AppointmentsTable from '../../../components/AppointmentsTable';
import NowCenteredAppointments from './NowCenteredAppointments';
import DaySummary, { DaySummaryData } from './DaySummary';
import { GeneralSettingsData } from '../../../models';
import { EntityType } from '../../../store/entities/state';
import { openClient, openEntity, loadEntities } from '../../../store/entities/actions';
import EuroIcon from '@material-ui/icons/Euro';
import { isPaid } from '../../../shared/models-helpers/appointmentDataHelper';
import Add from '@material-ui/icons/Add';
import cn from 'classnames';
import Typography from '../../../components/Typography';
import { isLoadingEntities } from '../../../store/entities/selectors';
import ToolTip from '../../../components/ToolTip';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getAdminPaymentsAsync, getAppointmentsAsync, getMyAppointmentsAsync, getPackAsync } from '../../../ajax/requests';
import { formatEuros, shortenName } from '../../../shared/string';
import Holidays from 'date-holidays';
import { useGeneralSettings } from '../../../store/settings/hooks';
import { useCookies } from 'react-cookie';
import { formatPackInfo, formatPayment } from '../../../components/AppointmentsTable/AppointmentsTable';
import moment from 'moment';
import { CheckInputField } from '../../../components/Forms/fields/CheckInputField';
import SettingsIcon from "@material-ui/icons/Settings";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import ImportAppointmentsModal from './ImportAppointments/ImportAppointmentsModal';
import DeleteAppointmentsModal from './DeleteAppointments/DeleteAppointmentsModal';
import { AvailabilityCheckerModal } from './AvailabilityChecker';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import CheckIcon from '@material-ui/icons/Check';
import CancelOutlinedIcon from '@material-ui/icons/Close';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import InventoryIcon from '@material-ui/icons/Widgets';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';
import PhonelinkEraseIcon from '@material-ui/icons/PhonelinkErase';
import DeviceUnknownIcon from '@material-ui/icons/DeviceUnknown';
import { canSeePrices, getMyProffesionalData, getMyUser, isProfessional } from '../../../store/session/selectors';
import { useHistory, useLocation } from 'react-router-dom';
import { getSelectedBranch } from '../../../store/general/selectors';
import { CalendarColumn } from '../../../components/CustomDayCalendar/CustomDayCalendar';
import { useRoomBlockedPeriods } from './useRoomBlockedPeriods';
import { Presentation } from './homeTypes';
import { ApplicationState } from '../../../store';
import { serviceName, serviceId } from '../../../shared/appointmint/appointment';
import { buildAppointmentStartDateTime, buildReplacementAppointmentDraft } from '../../../shared/appointmint/appointmentDeletion';
import { getAppointmentConfirmationStatus, AppointmentConfirmationEditableStatus } from '../../../shared/appointmint/appointmentConfirmationStatus';
import { SendSurveyModal, useSendSurveyAction } from '../../../components/Surveys/useSendSurveyAction';
import { alertError, alertSuccess } from '../../../store/alerts/actions';
import { getClientAsync, getWaitingListAsync, sendClientCommunicationAsync, updateMePreferencesAsync } from '../../../ajax/requests';
import { getErrorMessage } from '../../../ajax/errors';
import { updateGeneralSettings } from '../../../store/settings/actions';
import { useAppointmentDeletionFlow } from '../../../components/Appointments/AppointmentDeletionFlow';
import AppointmentContextMenu from '../../../components/Appointments/AppointmentContextMenu';
import { AbsenceModal } from './AbsenceModal';
import { updateMeProfessionalAsync, updateProfessionalAsync, getProfessionalAsync, getProfessionalMeAsync } from '../../../ajax/requests';
import { isAdministrator } from '../../../store/session/selectors';
import { DateInterval } from '../../../models/api-models';
import { paths } from '../../../app/constants';
import { basicFilters } from '../../Billing/filters';
import { updateSessionUser } from '../../../store/session/actions';
import CashRegisterQuickAction from './CashRegisterQuickAction';
import {
  AppointmentToolTipField,
  appointmentToolTipFieldsAll,
  buildHomeCalendarState,
  CalendarSettings,
  columnWidthOptions,
  ColumnWidth,
  getLegacyHomeCalendarPreferences,
  getSavedHomeCalendarPreferences,
  HomeCalendarState,
  homeCalendarPreferenceCookieKeys,
  hasHomeCalendarPreferenceValues,
  reconcileColumnOrder,
  slotGranularityOptions,
  SlotGranularity,
  toHomeCalendarPreferences,
} from './homeCalendarPreferences';

const holidays = new Holidays('PT', {languages: 'pt-PT', timezone: 'Europe/Lisbon'}) // TODO - get Country from settings
const isHoliday = (date: Date): boolean => (holidays.isHoliday(date) as Holidays.Holiday).type === 'public'

export interface HomeStateProps {
  appointmentsSelected: AppointmentData[],
  canSeeAppointments: boolean,
  settings: GeneralSettingsData,
  professionals: ProfessionalData[],
  canCreateEntities: EntityType[],
}

export interface HomeDispatchProps {
  onEditAppointment: (appointment: AppointmentData, forceEdition?: boolean) => void,
  onCreateEntity: (type: EntityType, initialValue?: any) => void,
  onEditPayment: (appointment: AppointmentData) => void,
  onQuickPayment: (appointment: AppointmentData, paymentType: string) => void,
  onCreateInvoice: (appointment: AppointmentData) => void,
  onDeleteAppointment: (appointment: AppointmentData, deleteEntireGroup?: boolean, reason?: AppointmentChangeReason) => Promise<void>,
  onMarkAppointmentDone: (appointment: AppointmentData, hasHappened: boolean | undefined) => void,
  onSetAppointmentConfirmationStatus: (appointment: AppointmentData, status: AppointmentConfirmationEditableStatus) => void,
}

export type HomeProps = HomeStateProps & HomeDispatchProps;

export const getDateDisplayString = (t: Translate<TK>, date: Date): string =>
  `${t(getWeekDayTranslationKey(date.getDay()))} (${date.getDate()}/${date.getMonth()+1})`;


const getAppointmentCalendarContent = (
  appointment: AppointmentData,
  t: Translate<TK>,
  confirmationFeatureAvailable: boolean,
) => {
  const paid = isPaid(appointment) && !!appointment.clientId;
  const showPaymentIcon = !!appointment.clientId && appointment.price > 0;
  const confirmationStatus = confirmationFeatureAvailable ? getAppointmentConfirmationStatus(appointment) : null;
  const hasCornerIcons = showPaymentIcon || !!appointment.recurring || !!confirmationStatus;
  const cornerIconCount = (showPaymentIcon ? 1 : 0) + (appointment.recurring ? 1 : 0) + (confirmationStatus ? 1 : 0);

  const hasLeftIcon = appointment.hasHappened !== undefined;
  const paddingLeft = hasLeftIcon ? 'calc(0.85rem + 1px)' : undefined;
  const paddingRight = hasCornerIcons ? `calc(${cornerIconCount} * 0.9rem + ${cornerIconCount} * 2px)` : undefined;

  return (
    <span style={{ display: 'block', position: 'relative', paddingLeft, paddingRight, height: '100%' }}>
      {hasCornerIcons && (
        <span className="apt-corner-icons">
          {!!appointment.recurring && <span className="apt-corner-icon apt-corner-icon--recurring"><AutorenewIcon /></span>}
          {confirmationStatus === 'confirmed' && <span className="apt-corner-icon apt-corner-icon--confirmed"><MobileFriendlyIcon /></span>}
          {confirmationStatus === 'rejected' && <span className="apt-corner-icon apt-corner-icon--rejected"><PhonelinkEraseIcon /></span>}
          {confirmationStatus === 'pending' && <span className="apt-corner-icon apt-corner-icon--pending"><DeviceUnknownIcon /></span>}
          {showPaymentIcon && <span className={`apt-corner-icon ${paid ? 'apt-corner-icon--paid' : 'apt-corner-icon--not-paid'}`}><EuroIcon /></span>}
        </span>
      )}
      {appointment.hasHappened === true && <span className="apt-left-icon apt-left-icon--happened"><CheckIcon /></span>}
      {appointment.hasHappened === false && <span className="apt-left-icon apt-left-icon--not-happened"><CancelOutlinedIcon /></span>}
      {appointment.clientRequest === ClientRequestType.Create && <b>🧑&nbsp;</b>}
      {appointment.clientRequest === ClientRequestType.Cancel && <b>🙅‍♂️&nbsp;</b>}
      {appointment.clientRequest === ClientRequestType.Reschedule && <b>🙋‍♂️&nbsp;</b>}
      {shortenName(appointment.clientName || appointment.type || t(TK.unknown))}
      {(appointment.groupClients?.length ?? 0) > 0 && ` (${appointment.groupClients!.length})`}
    </span>
  );
}

const getConfirmationRequestSentAt = (appointment: AppointmentData): Date | null => {
  const startDate = buildAppointmentStartDateTime(appointment);
  if (!startDate) return null;

  const requestHours = [
    ...(appointment.confirmationRequestsSentBySms ?? []),
    ...(appointment.confirmationRequestsSentByWhatsapp ?? []),
  ];
  if (!requestHours.length) return null;

  const latestHoursBefore = Math.min(...requestHours);
  return new Date(startDate.getTime() - latestHoursBefore * 60 * 60 * 1000);
}

const formatDateTime = (value?: string | Date | null): string => {
  if (!value) return '';
  return moment(value).format('DD/MM/YYYY HH:mm');
}

const getToolTipContent = (
  a: AppointmentData,
  t: Translate<TK>,
  fields: Record<AppointmentToolTipField, boolean>,
  confirmationFeatureAvailable: boolean,
  generalSettings: GeneralSettingsData,
) => {
  const confirmationStatus = fields['confirmation'] && confirmationFeatureAvailable
    ? getAppointmentConfirmationStatus(a)
    : null;
  const confirmationLabel = confirmationStatus === 'confirmed'
    ? t(TK.clientConfirmedAppointment)
    : confirmationStatus === 'rejected'
      ? t(TK.clientRejectedAppointment)
      : confirmationStatus === 'pending'
        ? t(TK.clientAwaitingConfirmation)
        : '';
  const confirmationDate = confirmationStatus === 'confirmed'
    ? a.confirmedByClientAt
    : confirmationStatus === 'rejected'
      ? a.deniedByClientAt
      : getConfirmationRequestSentAt(a);
  const confirmationDateLabel = confirmationStatus ? formatDateTime(confirmationDate) : '';

  return (
    <div className="toolTipContent">
      {fields['time'] && <p style={{margin: '5px'}}>{a.start} - {a.end}</p>}
      {fields['client'] && <p><b>{a.clientName}</b></p>}
      {fields['type'] && fields['professional'] && <p>{serviceName(a.type, generalSettings)} ({a.professionalName})</p>}
      {!fields['type'] && fields['professional'] && <p>{a.professionalName}</p>}
      {fields['type'] && !fields['professional'] && <p>{serviceName(a.type, generalSettings)}</p>}
      {fields['room'] && <p>{a.room}</p>}
      {confirmationStatus && <Typography><b>{t(TK.confirmation)}:</b> {confirmationLabel}{confirmationDateLabel ? ` (${confirmationDateLabel})` : ''}</Typography>}
      {fields['payment'] && <p>{formatPayment(t, a)}</p>}
      {fields['pack'] && !!a.packId && !!a.packAppointmentPosition ? <Typography><b>{t(TK.pack)}:</b> {formatPackInfo(a)}</Typography> : undefined}
      {fields['notes'] && !!a.notes?.trim().length ? <Typography><b>{t(TK.notes)}:</b> {a.notes}</Typography> : undefined}
      {a.clientRequest === ClientRequestType.Create && <b>🧑 {t(TK.createdByTheClient)}</b>}
      {a.clientRequest === ClientRequestType.Cancel && <b>🙅‍♂️ {t(TK.cancelRequestedByTheClient)}</b>}
      {a.clientRequest === ClientRequestType.Reschedule && <b>🙋‍♂️ {t(TK.rescheduleRequestedByTheClient)}</b>}
    </div>
  );
}

const getColumnName = (columnType: Presentation, appointment: AppointmentData, t: Translate<TK>): string => {
  switch(columnType){    
    case 'room': return appointment.room;
    case 'professional': return appointment.professionalName || t(TK.unknown);
    case 'day':
    case 'week': return getDateDisplayString(t, new Date(appointment.date));
  }
}

const mapAppointmentsToCalendar = (
  t: Translate<TK>,
  appointments: AppointmentData[],
  columnType: Presentation,
  calendarSettings: CalendarSettings,
  generalSettings: GeneralSettingsData,
  confirmationFeatureAvailable: boolean,
  onOpenAppointmentEdition: (a: AppointmentData) => void,
  onOpenAppointmentContextMenu: (a: AppointmentData, event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
): CalendarSchedule[] => {

  const getColorForAppointment = (a: AppointmentData, p?: ProfessionalData): string => {
    if (calendarSettings.colors === 'professional') {
      return p?.colorCode || a.professionalColor || generalSettings.services[a.type]?.color || "#00b07f";
    } else if (calendarSettings.colors === 'service') {
      return generalSettings.services[a.type]?.color || (p?.colorCode || a.professionalColor) || "#00b07f";
    }
    return (columnType === 'professional' 
      ? (generalSettings.services[a.type]?.color || p?.colorCode || a.professionalColor)
      : (p?.colorCode || a.professionalColor)
    ) ?? "#00b07f";
  }

  return appointments.flatMap<CalendarSchedule>(a => {
    const res: CalendarSchedule[] = [{
      id: a.id,
      content: getAppointmentCalendarContent(a, t, confirmationFeatureAvailable),
      color: getColorForAppointment(a),
      toolTipContent: getToolTipContent(a, t, calendarSettings.tooltipFields ?? {}, confirmationFeatureAvailable, generalSettings),
      columnName: getColumnName(columnType , a, t),
      startMinutesOfDay: parseTimeStringToMinutes(a.start),
      endMinutesOfDay: parseTimeStringToMinutes(a.end),
      onClick: () => onOpenAppointmentEdition(a),
      onContextMenu: (_, e) => onOpenAppointmentContextMenu(a, e),
    }]

    if (a.additionalProfessionals?.length && columnType === 'professional') {
      res.push(...a.additionalProfessionals.map<CalendarSchedule>(p => ({
        id: `${a.id}-${p.id}`,
        content: getAppointmentCalendarContent(a, t, confirmationFeatureAvailable),
        color: getColorForAppointment(a, p),
        toolTipContent: getToolTipContent(a, t, calendarSettings.tooltipFields ?? {}, confirmationFeatureAvailable, generalSettings),
        columnName: columnType === 'professional' ? p.name : getColumnName(columnType , a, t),
        startMinutesOfDay: parseTimeStringToMinutes(a.start),
        endMinutesOfDay: parseTimeStringToMinutes(a.end),
        onClick: () => onOpenAppointmentEdition(a),
        onContextMenu: (_, e) => onOpenAppointmentContextMenu(a, e),
      })))
    }

    return res
  })
}

const getDateAddingDays = (dateStr: string, addDays: number): Date => {
  const ret = new Date(dateStr);
  ret.setDate(ret.getDate()+addDays);
  return ret;
}

const toWeekDay = (date: Date): DayOfWeekEnum => isHoliday(date) ? DayOfWeekEnum.Holiday : date.getDay()

const slotGranularityComboOptions: ComboFieldOption[] = slotGranularityOptions.map(minutes => ({
  value: String(minutes),
}));

const columnWidthLabelKeys = [TK.columnWidthVeryNarrow, TK.columnWidthNarrow, TK.columnWidthNormal, TK.columnWidthWide, TK.columnWidthVeryWide] as const;

export const getCalendarLayout = (columnWidthByView: Record<Presentation, ColumnWidth>, columnType: Presentation, mightExistOverlay: boolean) => ({
  columnsWidth: columnWidthByView[columnType],
  defaultDrawMode: mightExistOverlay ? 'name-only' as const : 'block' as const,
});

const Home: React.FC<HomeProps> = (props) => {
  const {
    appointmentsSelected,
    canSeeAppointments,
    canCreateEntities,
    professionals,
    settings,
    onEditAppointment,
    onEditPayment,
    onQuickPayment,
    onCreateInvoice,
    onDeleteAppointment,
    onCreateEntity,
    onMarkAppointmentDone,
    onSetAppointmentConfirmationStatus,
  } = props;

  const t = useTranslations();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const selectedInterval = (() => {
    const params = new URLSearchParams(location.search);
    const today = getDateString(new Date());
    return { from: params.get('from') ?? today, to: params.get('to') ?? today };
  })();

  const selectedBranch = useSelector(getSelectedBranch)
  const canEditPayments = useSelector(canSeePrices)
  const myProfessional = useSelector(getMyProffesionalData)
  const amIProfessional = useSelector(isProfessional)
  const isAdmin = useSelector(isAdministrator)

  const showOnlyMineWhileLoading = amIProfessional && professionals.length === 0;

  const appointmentsInSelectedInterval = useMemo(() => appointmentsSelected.filter(a =>
    a.date >= selectedInterval.from && a.date <= selectedInterval.to &&
    (!showOnlyMineWhileLoading || a.professionalId === myProfessional?.id || a.additionalProfessionals?.some(p => p.id === myProfessional?.id))
  ), [appointmentsSelected, selectedInterval.from, selectedInterval.to]);

  const [cookies] = useCookies([...homeCalendarPreferenceCookieKeys])

  const onSelectedIntervalChanged = useCallback((from: string, to: string) => {
    const params = new URLSearchParams(location.search);
    params.set('from', from);
    params.set('to', to);
    history.replace({ search: params.toString() });
    const fetcher = canSeeAppointments
      ? () => getAppointmentsAsync(from, to, undefined, true)
      : () => getMyAppointmentsAsync(from, to, true);
    dispatch(loadEntities('appointments', fetcher, 'NewResult', e => e.date >= from && e.date <= to));
  }, [history, location.search, dispatch, canSeeAppointments]);


  const [showImportAppointments, setShowImportAppointments] = useState(false);
  const [showDeleteAppointments, setShowDeleteAppointments] = useState(false);
  const [availabilityCheckerOpen, setAvailabilityCheckerOpen] = useState(false);

  const [absenceModal, setAbsenceModal] = useState<{
    absence: DateInterval;
    isEdit: boolean;
    professional: ProfessionalData;
  } | null>(null)

  const buildAbsenceClickHandler = useCallback((professional: ProfessionalData) => {
    if (myProfessional?.id !== professional.id && !isAdmin) return undefined;
    return (absence: DateInterval) => setAbsenceModal({ absence, isEdit: true, professional });
  }, [myProfessional, isAdmin]);
  const myUser = useSelector(getMyUser)
  const generalSettings = useGeneralSettings()
  const confirmationFeatureAvailable = useSelector(
    (state: ApplicationState) => (state.settings.reminders?.appointmentConfirmation?.channels?.length ?? 0) > 0
  )
  const cashRegisterEnabled = useSelector(
    (state: ApplicationState) => !!state.settings.cashRegisterSettings?.enabled
  )
  const branchCount = useMemo(() => Object.keys(generalSettings.branches ?? {}).length, [generalSettings.branches])

  const rooms = useMemo(() => ({
    ...generalSettings.rooms,
    ...(selectedBranch ? generalSettings.branches?.[selectedBranch]?.rooms ?? {} : {}),
  }), [generalSettings, selectedBranch])
  const roomsSet = useMemo(() => Object.keys(rooms), [rooms])
  const roomsWithMultipleCapacity = roomsSet.filter(room => rooms[room]?.maxCapacity > 1)
  const professionalsForBranch = useMemo(
    () => selectedBranch
      ? professionals.filter(p => (p.branchTimeAvailability?.[selectedBranch]?.length ?? 0) > 0)
      : professionals,
    [professionals, selectedBranch],
  )
  const professionalsSet = useMemo(
    () => professionalsForBranch.map(p => p.name),
    [professionalsForBranch],
  )
  const savedHomeCalendarPreferences = useMemo(
    () => getSavedHomeCalendarPreferences(myUser?.preferences, selectedBranch, branchCount),
    [branchCount, myUser?.preferences, selectedBranch],
  )
  const legacyHomeCalendarPreferences = useMemo(() => getLegacyHomeCalendarPreferences(cookies), [cookies])
  const preferredHomeCalendarPreferences = useMemo(
    () => hasHomeCalendarPreferenceValues(savedHomeCalendarPreferences)
      ? savedHomeCalendarPreferences
      : legacyHomeCalendarPreferences,
    [legacyHomeCalendarPreferences, savedHomeCalendarPreferences],
  )
  const initialHomeCalendarState = useMemo(
    () => buildHomeCalendarState(preferredHomeCalendarPreferences, roomsSet, professionalsSet),
    [preferredHomeCalendarPreferences, professionalsSet, roomsSet]
  )
  const roomsSetRef = React.useRef(roomsSet)
  const professionalsSetRef = React.useRef(professionalsSet)

  const [columnType, setColumnsType] = React.useState<Presentation>(initialHomeCalendarState.columnType);
  const [selectedEntity, setSelectedEntity] = React.useState<string|undefined>(professionals.length === 1 ? professionals[0].name : undefined);
  const [roomColumnOrder, setRoomColumnOrder] = React.useState<string[]>(initialHomeCalendarState.roomColumnOrder)
  const [professionalColumnOrder, setProfessionalColumnOrder] = React.useState<string[]>(initialHomeCalendarState.professionalColumnOrder)
  const lastSavedHomeCalendarRef = React.useRef<HomeCalendarPreferencesData | null>(null)
  const pendingHomeCalendarStateRef = React.useRef<{ version: number, state: HomeCalendarState } | null>(null)
  const persistHomeCalendarStateTimerRef = React.useRef<number | null>(null)
  const latestHomeCalendarStateVersionRef = React.useRef(0)

  const loading = useSelector(isLoadingEntities('appointments'))

  const [calendarSettingsModalOpen, setCalendarSettingsModalOpen] = React.useState(false)
  const [calendarSettings, setCalendarSettingsState] = React.useState<CalendarSettings>(initialHomeCalendarState.calendarSettings);

  const flushHomeCalendarState = useCallback((version: number, state: HomeCalendarState) => {
    const nextPreferences = toHomeCalendarPreferences(state, myUser?.preferences, selectedBranch, branchCount);
    const optimisticCalendarPreferences = getSavedHomeCalendarPreferences(nextPreferences, selectedBranch, branchCount);
    if (optimisticCalendarPreferences) {
      lastSavedHomeCalendarRef.current = optimisticCalendarPreferences;
    }
    dispatch(updateSessionUser({ preferences: nextPreferences }));

    void updateMePreferencesAsync(nextPreferences)
      .then(updatedPreferences => {
        const updatedHomeCalendarPreferences = getSavedHomeCalendarPreferences(updatedPreferences, selectedBranch, branchCount);
        if (version !== latestHomeCalendarStateVersionRef.current || !updatedHomeCalendarPreferences) {
          return;
        }

        lastSavedHomeCalendarRef.current = updatedHomeCalendarPreferences;
        dispatch(updateSessionUser({ preferences: updatedPreferences }));
      })
      .catch(error => {
        const message = getErrorMessage(error);
        if (typeof message === 'string' && message.trim().length) {
          dispatch(alertError(message));
        }
      });
  }, [branchCount, dispatch, myUser?.preferences, selectedBranch])

  const persistHomeCalendarState = useCallback((state: HomeCalendarState) => {
    const version = latestHomeCalendarStateVersionRef.current + 1
    latestHomeCalendarStateVersionRef.current = version
    pendingHomeCalendarStateRef.current = { version, state }

    if (persistHomeCalendarStateTimerRef.current != null) {
      window.clearTimeout(persistHomeCalendarStateTimerRef.current)
    }

    persistHomeCalendarStateTimerRef.current = window.setTimeout(() => {
      const pending = pendingHomeCalendarStateRef.current
      pendingHomeCalendarStateRef.current = null
      persistHomeCalendarStateTimerRef.current = null

      if (pending) {
        flushHomeCalendarState(pending.version, pending.state)
      }
    }, 250)
  }, [flushHomeCalendarState])

  React.useEffect(() => () => {
    if (persistHomeCalendarStateTimerRef.current != null) {
      window.clearTimeout(persistHomeCalendarStateTimerRef.current)
      persistHomeCalendarStateTimerRef.current = null
    }

    const pending = pendingHomeCalendarStateRef.current
    pendingHomeCalendarStateRef.current = null
    if (pending) {
      flushHomeCalendarState(pending.version, pending.state)
    }
  }, [flushHomeCalendarState])

  React.useEffect(() => {
    roomsSetRef.current = roomsSet
    professionalsSetRef.current = professionalsSet
  }, [professionalsSet, roomsSet])

  const setCalendarSettings = (value: CalendarSettings) => {
    setCalendarSettingsState(value)
    persistHomeCalendarState({
      columnType,
      calendarSettings: value,
      roomColumnOrder,
      professionalColumnOrder,
    })
  }

  const todayDateString = getDateDisplayString(t, new Date())
  const todayStr = getDateString(new Date())

  const currentWeekDates = useMemo(() => {
    const monday = new Date(selectedInterval.from);
    while (monday.getDay() !== 1) monday.setDate(monday.getDate() - 1);
    return [0,1,2,3,4,5,6].map(d => {
      const date = new Date(monday);
      date.setDate(date.getDate() + d);
      return date;
    });
  }, [selectedInterval.from]);

  const dates = columnType === 'week'
    ? [0,1,2,3,4,5,6].map(d => getDateAddingDays(selectedInterval.from, d))
    : [new Date(selectedInterval.from)]

  React.useEffect(() => {
    // On professional login auto selects itself
    if (professionals.length === 1 && !selectedEntity && columnType !== 'professional') setSelectedEntity(professionals[0].name)
  }, [columnType, professionals, selectedEntity])

  React.useEffect(() => {
    if (!preferredHomeCalendarPreferences || preferredHomeCalendarPreferences === lastSavedHomeCalendarRef.current) {
      return;
    }

    const nextState = buildHomeCalendarState(preferredHomeCalendarPreferences, roomsSetRef.current, professionalsSetRef.current);
    setColumnsType(nextState.columnType);
    setCalendarSettingsState(nextState.calendarSettings);
    setRoomColumnOrder(nextState.roomColumnOrder);
    setProfessionalColumnOrder(nextState.professionalColumnOrder);
  }, [preferredHomeCalendarPreferences]);

  React.useEffect(() => {
    setRoomColumnOrder(current => {
      const next = reconcileColumnOrder(current, preferredHomeCalendarPreferences?.roomColumnOrder, roomsSet);
      return current.length === next.length && current.every((value, index) => value === next[index]) ? current : next;
    });
    setProfessionalColumnOrder(current => {
      const next = reconcileColumnOrder(current, preferredHomeCalendarPreferences?.professionalColumnOrder, professionalsSet);
      return current.length === next.length && current.every((value, index) => value === next[index]) ? current : next;
    });
  }, [professionalsSet, roomsSet, preferredHomeCalendarPreferences]);

  const roomColumnNames = reconcileColumnOrder(roomColumnOrder, undefined, roomsSet)
  const professionalColumnNames = reconcileColumnOrder(professionalColumnOrder, undefined, professionalsSet)

  const columns = columnType === 'room' ? roomColumnNames.map(name => ({name, value: name}))
      : columnType === 'professional' ? professionalColumnNames.map(name => ({name, value: name}))
      : dates.map(d => ({
        value: d,
        name: getDateDisplayString(t, d),
        highlighted: (columnType === 'day' || columnType === 'week') && getDateDisplayString(t, d) === todayDateString,
        lowlighted: (columnType === 'day' || columnType === 'week') && isHoliday(d),
        subtitle: (columnType === 'day' || columnType === 'week') && isHoliday(d) ? t(TK.holiday) : undefined,
      }))

  const handleMoveColumn = (source: number, target: number) => {
    const newColumns = [...columns]
    newColumns.splice(source, 1)
    newColumns.splice(target, 0, columns[source])
    if (columnType === 'room') {
      const nextRoomColumnOrder = newColumns.map(i => i.name)
      setRoomColumnOrder(nextRoomColumnOrder)
      persistHomeCalendarState({
        columnType,
        calendarSettings,
        roomColumnOrder: nextRoomColumnOrder,
        professionalColumnOrder,
      })
    }
    if (columnType === 'professional') {
      const nextProfessionalColumnOrder = newColumns.map(i => i.name)
      setProfessionalColumnOrder(nextProfessionalColumnOrder)
      persistHomeCalendarState({
        columnType,
        calendarSettings,
        roomColumnOrder,
        professionalColumnOrder: nextProfessionalColumnOrder,
      })
    }
  }

  const handleSelectedDateChange = (date: string) => {
    const isWeek = columnType === 'week';
    if(isWeek){
      const from = new Date(date);
      while(from.getDay() !== 1) from.setDate(from.getDate()-1);
      const to = new Date(from);
      to.setDate(to.getDate()+6);
      onSelectedIntervalChanged(from.toISOString().substr(0,10), to.toISOString().substr(0,10));
    }
    else {
      onSelectedIntervalChanged(date, date);
    }
  }

  const moveIntervalWindow = (forward: boolean) => {
    const isWeek = columnType === 'week';
    const daysToAdd = forward ? (isWeek ? 8 : 1) : (isWeek ? -7 : -1);
    handleSelectedDateChange(addDayToDateString(selectedInterval.from, daysToAdd));
  }

  const handleSelectedColumnTypeChange = (newColumnType: Presentation) => {
    setColumnsType(newColumnType)
    persistHomeCalendarState({
      columnType: newColumnType,
      calendarSettings,
      roomColumnOrder,
      professionalColumnOrder,
    })
    if(selectedEntity && newColumnType !== 'week') {
      setSelectedEntity(undefined)
    }
  }

  // eslint-disable-next-line
  React.useEffect(() => {
    if (columnType !== 'week') {
      const today = getDateString(new Date());
      if (today >= selectedInterval.from && today <= selectedInterval.to) {
        handleSelectedDateChange(today);
        return;
      }
    }
    handleSelectedDateChange(selectedInterval.from);
  }, [columnType]);

  const selectedEntityAppointments = React.useMemo(() => {
    if (!selectedEntity) return appointmentsInSelectedInterval.sort((a, b) => (a.date+a.start) > (b.date+b.start) ? 1 : -1);
    const basicFilter = basicFilters.find(f => t(f.labelKey) === selectedEntity);
    const filtered = basicFilter
      ? appointmentsInSelectedInterval.filter(a => basicFilter.predicate!(a, [], {} as any))
      : appointmentsInSelectedInterval.filter(a => a.professionalName === selectedEntity || a.room === selectedEntity || a.clientName === selectedEntity || a.additionalProfessionals?.some(p => p.name === selectedEntity) || a.type === serviceId(selectedEntity, generalSettings));
    return filtered.sort((a, b) => (a.date+a.start) > (b.date+b.start) ? 1 : -1);
  }, [selectedEntity, appointmentsInSelectedInterval, generalSettings, t])

  console.log('selectedEntityAppointments', selectedEntityAppointments)
  console.log('selectedEntity', selectedEntity)

  const showAppointmentsFilter = React.useMemo(() => columnType === 'week' || columnType === 'day', [columnType])
  
  const mightExistOverlay = Boolean(canSeeAppointments && (
    (showAppointmentsFilter && !selectedEntity) || 
    (columnType === 'room' && roomsWithMultipleCapacity.length > 0) || 
    (selectedEntity && roomsWithMultipleCapacity.includes(selectedEntity))
  ))

  const basicFilterLabels = useMemo(() => basicFilters.map(f => t(f.labelKey)), [t]);

  const entityOptions = showAppointmentsFilter && canSeeAppointments
    ? [...basicFilterLabels, ...roomsSet, ...professionals.map(p => p.name), ...Object.entries(generalSettings.services).map(([k, s]) => s.name ?? k), ...new Set(appointmentsInSelectedInterval.map(a => a.clientName!))]
    : [];

  const availabilitySchedules = columnType === 'room' ? [] : (() => {
    const professionalsFiltered = columnType === 'professional' || professionalsForBranch.length === 1
      ? professionalsForBranch
      : professionalsForBranch.filter(p => p.name === selectedEntity)

    return dates.flatMap((date, date_i) => professionalsFiltered.flatMap(p => {
      const columnName = columnType === 'professional' ? p.name : columns[date_i]?.name
      return getProfessionalAvailabilitySchedules(
        p,
        date,
        getDateString(date),
        columnName,
        selectedBranch,
        selectedInterval.to,
        t(TK.absence),
        toWeekDay,
        undefined,
        buildAbsenceClickHandler(p),
      )
    }))
  })()

  const companyAbsenceSchedules = React.useMemo(() => {
    const companyAsAvailability: AvailabilityProfessional = {
      id: '__company__',
      absences: settings.absences,
    };
    return dates.flatMap((date, date_i) => {
      // In week/day view columns are the dates themselves — only use the matching column.
      // In professional/room views all columns should show the company absence.
      const targetColumns = (columnType === 'week' || columnType === 'day')
        ? (columns[date_i] ? [columns[date_i]] : [])
        : columns;
      return targetColumns.flatMap(col =>
        getProfessionalAvailabilitySchedules(
          companyAsAvailability,
          date,
          getDateString(date),
          col.name,
          undefined,
          selectedInterval.to,
          t(TK.absence),
          toWeekDay,
        )
      );
    });
  }, [settings.absences, dates, columns, columnType, selectedInterval.to, t]);

  const roomsOcupancy = !myProfessional || columnType !== 'room' || canSeeAppointments ? [] : appointmentsInSelectedInterval
    .filter(a => a.professionalId !== myProfessional?.id)
    .map<CalendarSchedule>(a => {
      const professionalName = a.professionalName
        || t(TK.unknown)
      const busyByText = `${t(TK.busy)} ${t(TK.by)} ${professionalName}`
      return {
        id: a.id,
        columnName: a.room,
        color: '#AAAAAA',
        opacity: 1,
        startMinutesOfDay: parseTimeStringToMinutes(a.start),
        endMinutesOfDay: parseTimeStringToMinutes(a.end),
        content: busyByText,
        toolTipContent: busyByText,
      }
    })

  const roomBlockedPeriods = useRoomBlockedPeriods({
    columnType,
    dates,
    rooms,
    settings,
    columns,
    t,
    toWeekDay,
  })

  const showSummaryButton = useMemo(
    () => canSeeAppointments && columnType !== 'week', 
    [canSeeAppointments, columnType])
  const [loadingSummary, setLoadingSummary] = useState<boolean>(false)
  const [summaryData, setSummaryData] = useState<DaySummaryData | null>(null)

  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    appointment: AppointmentData;
  } | null>(null)

  const [backgroundContextMenu, setBackgroundContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    date: string;
    minutes: number;
    column: CalendarColumn;
  } | null>(null)

  const [cashRegisterAppointment, setCashRegisterAppointment] = useState<AppointmentData | null>(null)

  const [surveyTargetAppointment, setSurveyTargetAppointment] = useState<AppointmentData | null>(null)
  const activeSurveyAppointment = surveyTargetAppointment ?? contextMenu?.appointment ?? null
  const sendSurveyAction = useSendSurveyAction(
    activeSurveyAppointment?.clientId ?? '',
    activeSurveyAppointment?.id,
    undefined,
    () => setSurveyTargetAppointment(null),
  )

  const clickSnapMinutes = calendarSettings.slotGranularity % 15 === 0 ? 15 : calendarSettings.slotGranularity

  const onCalendarClick = (column: CalendarColumn, minutes: number) => {
    const professional = columnType === 'professional' ? professionals.find(p => p.name === column.name) : undefined
    const room = columnType === 'room' ? column.name : undefined

    const minutesTruncated = Math.floor(minutes / clickSnapMinutes) * clickSnapMinutes

    onCreateEntity('appointments', {
        professionalId: professional?.id,
        professionalName: professional?.name,
        professionalColor: professional?.colorCode,
        room,
        start: minutesToTimeString(minutesTruncated),
        end: minutesToTimeString(minutesTruncated + 60),
        date: column.value instanceof Date ? column.value.toISOString().substr(0,10) : selectedInterval.from,
        branchId: selectedBranch,
      } as AppointmentData)
  }
  
  const onShowSummaryClick = useCallback(() => {
    if (loadingSummary) return
    setLoadingSummary(true)

    // Payments are allowed for appointments managers, only for 1 day, up to 7 days from now
    getAdminPaymentsAsync(selectedInterval.from, selectedInterval.from, selectedBranch ?? undefined)
      .then(payments => {
        setLoadingSummary(false)
        const perType = payments.reduce<Record<string, number>>((totals, payment) => ({
          ...totals,
          [payment.type]: (totals[payment.type] ?? 0) + payment.value,
        }), {})
        const totals = appointmentsInSelectedInterval.reduce(
          (total, val) => ({
            sumPrices: total.sumPrices + val.price,
            sumActualPrice: total.sumActualPrice + (val.actualPriceWithPack ?? val.price),
          }),
          {sumPrices: 0, sumActualPrice: 0})
        const appointmentPaymentsTotal = payments
          .filter(p => p.origin === PaymentOrigin.Appointment)
          .reduce((sum, p) => sum + p.value, 0)
        const packPaymentsTotal = payments
          .filter(p => p.origin === PaymentOrigin.Pack)
          .reduce((sum, p) => sum + p.value, 0)

        setSummaryData({
          totalPrice: totals.sumPrices,
          effectivePrice: totals.sumActualPrice,
          paymentsPerType: perType,
          appointmentPaymentsTotal,
          packPaymentsTotal,
        })
      })
      .catch(() => setLoadingSummary(false))
  }, [selectedInterval, loadingSummary, appointmentsInSelectedInterval])

  useEffect(() => setSummaryData(null), [selectedInterval.from, selectedInterval.to])

  const appointmentDeletion = useAppointmentDeletionFlow({
    appointmentChangeReasons: generalSettings?.appointmentChangeReasons,
    companyName: generalSettings?.companyName,
    executeDelete: (appointment, deleteEntireGroup, reason) => onDeleteAppointment(appointment, deleteEntireGroup, reason),
    getAppointmentTypeName: appointment => serviceName(appointment.type, generalSettings),
    loadWaitingList: appointment => getWaitingListAsync(appointment.type, appointment.professionalId).catch(() => []),
    loadWaitingListClient: clientId => getClientAsync(clientId).catch(() => undefined),
    onAddAppointmentChangeReason: newReason => dispatch(updateGeneralSettings({
      ...generalSettings,
      appointmentChangeReasons: [...(generalSettings.appointmentChangeReasons || []), newReason],
    })),
    onCreateReplacementAppointment: (appointment, item) => {
      setTimeout(() => onCreateEntity(
        'appointments',
        buildReplacementAppointmentDraft(appointment, item) as AppointmentData,
      ), 1500)
    },
    onDeleteBlocked: () => dispatch(alertError(t(TK.cannotDeleteAppointmentWithPaymentsOrInvoices))),
    onSmsError: error => dispatch(alertError(getErrorMessage(error) || t(TK.somethingWentWrong))),
    onSmsSent: () => dispatch(alertSuccess(t(TK.sentSuccessfully))),
    sendSms: (clientId, message) => sendClientCommunicationAsync(clientId, CommunicationType.SMS, message).then(() => undefined),
  })

  const onContextMenu = useCallback((appointment: AppointmentData, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setContextMenu({ mouseX: event?.clientX ?? 0, mouseY: event?.clientY ?? 0, appointment });
  }, []);

  const onCalendarBackgroundContextMenu = useCallback((column: CalendarColumn, minutes: number, event: React.MouseEvent) => {
    if (!amIProfessional && !isAdmin && !canCreateEntities.includes('appointments')) return
    event.preventDefault()
    const date = column.value instanceof Date ? column.value.toISOString().substr(0, 10) : selectedInterval.from
    setBackgroundContextMenu({ mouseX: event.clientX, mouseY: event.clientY, date, minutes, column })
  }, [amIProfessional, isAdmin, canCreateEntities, selectedInterval.from]);

  const handleSendSurveyModalClose = () => {
    sendSurveyAction.closeSendSurveyModal();
    setSurveyTargetAppointment(null);
  };

  const colorsMap = {
    [t(TK.professional)]: 'professional',
    [t(TK.service)]: 'service',
    [t(TK.automatic)]: 'auto',
    ['professional']: t(TK.professional),
    ['service']: t(TK.service),
    ['auto']: t(TK.automatic),
  }

  return (<>
    <TitledContainer 
      id="calendar"
      title={t(TK.calendar)}
      actions={[
        {
          id: 'add',
          Icon: Add,
          options: [
            {id: 'appointment', description: t(TK.createAppointment), icon: <EventIcon fontSize="small"/>, onClick: () => onCreateEntity('appointments', {branchId: selectedBranch}), enabled: canCreateEntities.includes('appointments')},
            {id: 'client', description: t(TK.client), icon: <PersonAddIcon fontSize="small"/>, onClick: () => onCreateEntity('clients'), enabled: canCreateEntities.includes('clients')},
            {id: 'professional', description: t(TK.professional), icon: <WorkIcon fontSize="small"/>, onClick: () => onCreateEntity('professionals'), enabled: canCreateEntities.includes('professionals')},
            {id: 'pack', description: t(TK.createPack), icon: <InventoryIcon fontSize="small"/>, onClick: () => onCreateEntity('clientPacks'), enabled: canCreateEntities.includes('clientPacks')},
            {id: 'order', description: t(TK.createOrder), icon: <ShoppingCartIcon fontSize="small"/>, onClick: () => onCreateEntity('orders'), enabled: canCreateEntities.includes('orders')},
            {id: 'personalTime', description: t(TK.bookPersonalTime), icon: <EventBusyIcon fontSize="small"/>, onClick: () => {
              if (!myProfessional) return;
              const now = moment();
              const startTime = now.format('HH:mm');
              const endTime = now.clone().add(1, 'hour').format('HH:mm');
              const today = now.format('YYYY-MM-DD');
              setAbsenceModal({ absence: { from: `${today}T${startTime}:00`, to: `${today}T${endTime}:00`, description: '' }, isEdit: false, professional: myProfessional });
            }, enabled: !!myProfessional},
            {id: 'checkAvailability', description: t(TK.checkAvailability), icon: <EventIcon fontSize="small"/>, onClick: () => setAvailabilityCheckerOpen(true), enabled: canCreateEntities.includes('appointments')},
          ].filter(o => o.enabled),
        },
      ]}
>

      <div className="topPanel">
        <div style={{display: 'flex', alignItems: 'center', gap: 'var(--spacer-XS)'}}>
          <DateField
            id="from"
            value={selectedInterval.from}
            type="date"
            onChange={day => day?.length && handleSelectedDateChange(day)}
          />
          <Button
            id="today-button"
            outline
            color="secondary"
            className="todayButton"
            onClick={() => handleSelectedDateChange(todayStr)}
          >
            {t(TK.today)}
          </Button>
          <div className="navArrows">
            <Button color="link" className="navArrow" id="move-back-button" onClick={() => moveIntervalWindow(false)}><ArrowBack /></Button>
            <Button color="link" className="navArrow" id="move-forward-button" onClick={() => moveIntervalWindow(true)}><ArrowForward /></Button>
          </div>
        </div>

        <div className="columnTypePanel">
          <ButtonGroup className="viewToggle">
            <Button id="select-day-button" outline color="info" active={columnType === 'day'} onClick={() => handleSelectedColumnTypeChange('day')}>
              <EventIcon/>
            </Button>
            <ToolTip target='select-day-button' toolTipContent={t(TK.day)}/>
            
            <Button id="select-week-button" outline color="info" active={columnType === 'week'} onClick={() => handleSelectedColumnTypeChange('week')}>
              <DateRangeIcon/>
            </Button>
            <ToolTip target='select-week-button' toolTipContent={t(TK.week)}/>
            
            <Button id="select-room-button" outline color="info" active={columnType === 'room'} onClick={() => handleSelectedColumnTypeChange('room')}>
              <DoorFrontIcon/>
            </Button>
            <ToolTip target='select-room-button' toolTipContent={t(TK.rooms)}/>

            { canSeeAppointments && 
              <>
                <Button id="select-professional-button" outline color="info" active={columnType === 'professional'} onClick={() => handleSelectedColumnTypeChange('professional')}>
                  <WorkIcon/>
                </Button>
                <ToolTip target='select-professional-button' toolTipContent={t(TK.professionals)}/>
              </>
            }
          </ButtonGroup>

        </div>
        
        {canSeeAppointments &&
            <AutocompleteTextField 
              id="search"
              className="searchBox"
              disabled={!showAppointmentsFilter}
              value={showAppointmentsFilter ? selectedEntity || '' : t(columnType === 'room' ? TK.rooms : TK.professionals)}
              options={entityOptions}
              placeholder={`${t(TK.filter)}...`}
              onValueChanged={selectedEntity => setSelectedEntity(selectedEntity)}/>
          }
      </div>

      {columnType !== 'week' ? (
        <div className="weekdayStrip">
          {currentWeekDates.map((date, i) => {
            const dateStr = getDateString(date);
            const isToday = dateStr === todayStr;
            const isSelected = dateStr === selectedInterval.from;
            const isHolidayDay = isHoliday(date);
            return (
              <div
                key={i}
                className={cn('weekdayItem', { today: isToday, selected: isSelected, holiday: isHolidayDay })}
                onClick={() => handleSelectedDateChange(dateStr)}
              >
                <span className="dayName">{t(getWeekDayTranslationKey(date.getDay())).substring(0, 3)}</span>
                <span className="dayNumber">{date.getDate()}</span>
              </div>
            );
          })}
        </div>
      ) : <hr/>}

      <div className={cn('appointmentsPanel', {'singleDayPanel': columnType === 'day'})}>
        {loading && <Typography style={{position: 'fixed', bottom: 0, left: 0, backgroundColor: 'white'}}>{t(TK.loading)}...</Typography>}
        
        <CustomDayCalendar
          className={cn('calendar', {'singleDayCalendar': columnType === 'day'})}
          openingHourInMinutesOfDay={parseTimeStringToMinutes(settings.openningHour)}
          closingHourInMinutesOfDay={parseTimeStringToMinutes(settings.closingHour)}
          stepInMinutes={calendarSettings.slotGranularity}
          columns={columns}
          onChangeColumnOrder={handleMoveColumn}
          onClick={onCalendarClick}
          onContextMenu={(amIProfessional || isAdmin || canCreateEntities.includes('appointments')) ? onCalendarBackgroundContextMenu : undefined}
          style={{minWidth: '235px'}}
          mouseLabel={m => `${t(TK.create)} ${minutesToTimeString(Math.floor(m / clickSnapMinutes) * clickSnapMinutes)}`}
          layout={getCalendarLayout(calendarSettings.columnWidthByView, columnType, mightExistOverlay)}
          onSettingsClick={() => setCalendarSettingsModalOpen(true)}
          schedules={[
            ...availabilitySchedules,
            ...companyAbsenceSchedules,
            ...roomsOcupancy,
            ...roomBlockedPeriods,
            ...mapAppointmentsToCalendar(
              t,
              selectedEntityAppointments,
              columnType,
              calendarSettings,
              settings,
              confirmationFeatureAvailable,
              onEditAppointment,
              onContextMenu),
          ]}/>
          
        <NowCenteredAppointments
          appointments={selectedEntityAppointments}
          selectedDate={selectedInterval.from}
        >
          <AppointmentsTable
            isLoading={false}
            className="appointmentsTable"
            canEdit={canCreateEntities.includes('appointments')}
            showExportCsv
            appointments={selectedEntityAppointments}
            settings={{ hideDay: columnType !== 'week', hideColumns: canSeeAppointments ? [] : ['professional'] }}
            onEditAppointment={onEditAppointment}
            onEditPayment={onEditPayment}
            onQuickPayment={canEditPayments ? onQuickPayment : undefined}
            onMarkAppointmentDone={onMarkAppointmentDone}
            onSetAppointmentConfirmationStatus={onSetAppointmentConfirmationStatus}
            onOpenClient={clientId => dispatch(openClient(clientId))}
            onOpenPack={packId => dispatch(openEntity('clientPacks', packId, () => getPackAsync(packId)))}
            onCreateInvoice={onCreateInvoice}
            onDeleteAppointment={(a) => appointmentDeletion.startDeletion(a)}
            onSendSurvey={sendSurveyAction.canRenderAction ? (a) => { setSurveyTargetAppointment(a); sendSurveyAction.openSendSurveyModal(); } : undefined}
            onRowContextMenu={onContextMenu} />
        </NowCenteredAppointments>
      </div>
      <div style={{display: 'flex', justifyContent: 'flex-end', gap: 'var(--spacer-XS)'}}>
        {isAdmin && (
          <Button color='link' size='sm' onClick={() => setShowImportAppointments(true)}>
            <CloudUploadIcon style={{width: '1.2rem'}}/>
            &nbsp;
            {t(TK.importAppointments)}
          </Button>
        )}
        {isAdmin && (
          <Button color='link' size='sm' onClick={() => setShowDeleteAppointments(true)}>
            <DeleteSweepIcon style={{width: '1.2rem'}}/>
            &nbsp;
            {t(TK.deleteAppointments)}
          </Button>
        )}
        <Button color='link' size='sm' onClick={() => setCalendarSettingsModalOpen(true)}>
          <SettingsIcon style={{width: '1.2rem'}}/>
          &nbsp;
          {t(TK.calendar)}
        </Button>
      </div>

      {showSummaryButton &&
        <DaySummary
          loading={loadingSummary}
          data={summaryData}
          branchName={selectedBranch ? generalSettings.branches?.[selectedBranch]?.displayName : undefined}
          showCashRegisterLink={cashRegisterEnabled}
          cashRegisterPath={paths.cashRegister()}
          onShow={onShowSummaryClick}
          onClose={() => setSummaryData(null)}
        />
      }
          
      <Modal size='sm' isOpen={calendarSettingsModalOpen} toggle={() => setCalendarSettingsModalOpen(false)}>
        <ModalHeader toggle={() => setCalendarSettingsModalOpen(false)}>{t(TK.settings)} - {t(TK.calendar)}</ModalHeader>
        <ModalBody style={{marginLeft: 'var(--spacer-S)'}}>
          <Typography block style={{marginBottom: 'var(--spacer-XS)'}}><b>{t(TK.tooltipFields)}</b></Typography>
          <div style={{marginLeft: 'var(--spacer-S)', display: 'flex', flexDirection: 'column'}}>
            {appointmentToolTipFieldsAll
              .filter(field => confirmationFeatureAvailable || field !== 'confirmation')
              .map(field => (
              <CheckInputField 
                key={field} 
                label={t(field as TK)}
                value={calendarSettings.tooltipFields[field]} 
                onChange={value => setCalendarSettings({...calendarSettings, tooltipFields: {...calendarSettings.tooltipFields, [field]: value}})} 
              />
            ))}
          </div>

          <Typography block style={{marginTop: 'var(--spacer-M)', marginBottom: 'var(--spacer-XS)'}}><b>{t(TK.color)}</b></Typography>
          <ComboField
            options={[
              t(TK.professional),
              t(TK.service),
              t(TK.automatic),
            ]}
            value={colorsMap[calendarSettings.colors ?? 'auto']}
            onChange={value => setCalendarSettings({...calendarSettings, colors: value ? colorsMap[value] as any : 'auto'})}
          />

          <Typography block style={{marginTop: 'var(--spacer-M)', marginBottom: 'var(--spacer-XS)'}}><b>{t(TK.slotGranularity)}</b></Typography>
          <ComboField
            options={slotGranularityComboOptions.map(option => ({
              ...option,
              label: `${option.value} ${t(TK.minutes)}`,
            }))}
            value={String(calendarSettings.slotGranularity)}
            onChange={value => {
              const minutes = value ? Number(value) : 60;
              setCalendarSettings({...calendarSettings, slotGranularity: (slotGranularityOptions as ReadonlyArray<number>).includes(minutes) ? minutes as SlotGranularity : 60});
            }}
          />

          <Typography block style={{marginTop: 'var(--spacer-M)', marginBottom: 'var(--spacer-XS)'}}><b>{t(TK.columnWidth)}</b></Typography>
          <ComboField
            options={columnWidthOptions.map((px, i) => ({
              value: String(px),
              label: t(columnWidthLabelKeys[i]),
            }))}
            value={String(calendarSettings.columnWidthByView[columnType])}
            onChange={value => {
              const px = Number(value);
              const width: ColumnWidth = (columnWidthOptions as ReadonlyArray<number>).includes(px) ? px as ColumnWidth : columnWidthOptions[1];
              setCalendarSettings({...calendarSettings, columnWidthByView: {...calendarSettings.columnWidthByView, [columnType]: width}});
            }}
          />
        </ModalBody>
      </Modal>
    </TitledContainer>

    {contextMenu && (
      <AppointmentContextMenu
        mouseX={contextMenu.mouseX}
        mouseY={contextMenu.mouseY}
        appointment={contextMenu.appointment}
        onClose={() => setContextMenu(null)}
        onConfirm={() => { const next = contextMenu.appointment.hasHappened === undefined ? true : contextMenu.appointment.hasHappened === true ? false : undefined; onMarkAppointmentDone(contextMenu.appointment, next); }}
        onEdit={() => onEditAppointment(contextMenu.appointment, true)}
        onEditPayment={() => onEditPayment(contextMenu.appointment)}
        onQuickPayment={paymentType => onQuickPayment(contextMenu.appointment, paymentType)}
        onCreateInvoice={() => onCreateInvoice(contextMenu.appointment)}
        onSendSurvey={() => { setSurveyTargetAppointment(contextMenu.appointment); sendSurveyAction.openSendSurveyModal(); }}
        canSendSurvey={Boolean(contextMenu.appointment.clientId) && sendSurveyAction.canRenderAction ? sendSurveyAction.canSendSurvey : undefined}
        sendSurveyDisabledMessage={sendSurveyAction.sendSurveyDisabledMessage}
        onOpenClient={contextMenu.appointment.clientId ? () => dispatch(openClient(contextMenu.appointment.clientId!)) : undefined}
        onOpenCashRegister={cashRegisterEnabled && contextMenu.appointment.clientId ? () => { setCashRegisterAppointment(contextMenu.appointment); setContextMenu(null); } : undefined}
        onDelete={() => appointmentDeletion.startDeletion(contextMenu.appointment)}
      />
    )}
    {appointmentDeletion.dialogs}

    {cashRegisterEnabled && (
      <CashRegisterQuickAction
        controlledOpen={!!cashRegisterAppointment}
        onControlledClose={() => setCashRegisterAppointment(null)}
        initialClientId={cashRegisterAppointment?.clientId ?? undefined}
      />
    )}

    {backgroundContextMenu && (
      <>
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 1299 }}
          onClick={() => setBackgroundContextMenu(null)}
          onContextMenu={e => { e.preventDefault(); setBackgroundContextMenu(null); }}
        />
        <div
          style={{
            position: 'fixed',
            top: backgroundContextMenu.mouseY,
            left: backgroundContextMenu.mouseX,
            zIndex: 1300,
            background: 'white',
            border: 'var(--border-thin) solid var(--appLigthGrey)',
            borderRadius: 4,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            minWidth: 180,
            overflow: 'hidden',
          }}
        >
          {canCreateEntities.includes('appointments') && (
            <button
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacer-XS)',
                width: '100%',
                textAlign: 'left',
                padding: 'var(--spacer-XS) var(--spacer-S)',
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                fontSize: '0.9rem',
              }}
              onClick={() => {
                const minutesTruncated = Math.floor(backgroundContextMenu.minutes / clickSnapMinutes) * clickSnapMinutes;
                const professional = columnType === 'professional' ? professionals.find(p => p.name === backgroundContextMenu.column.name) : undefined;
                const room = columnType === 'room' ? backgroundContextMenu.column.name : undefined;
                onCreateEntity('appointments', {
                  professionalId: professional?.id,
                  professionalName: professional?.name,
                  professionalColor: professional?.colorCode,
                  room,
                  start: minutesToTimeString(minutesTruncated),
                  end: minutesToTimeString(minutesTruncated + 60),
                  date: backgroundContextMenu.date,
                  branchId: selectedBranch,
                } as AppointmentData);
                setBackgroundContextMenu(null);
              }}
            >
              <Add style={{ fontSize: '1rem', color: 'var(--text-muted)' }} />
              {t(TK.appointment)}
            </button>
          )}
          {(() => {
            const colProfessional = columnType === 'professional'
              ? professionals.find(p => p.name === backgroundContextMenu.column.name)
              : undefined;
            const timeOffProfessional = colProfessional ?? myProfessional;
            if (!timeOffProfessional) return null;
            if (timeOffProfessional.id !== myProfessional?.id && !isAdmin) return null;
            return (
              <button
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'var(--spacer-XS)',
                  width: '100%',
                  textAlign: 'left',
                  padding: 'var(--spacer-XS) var(--spacer-S)',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  fontSize: '0.9rem',
                }}
                onClick={() => {
                  const startTime = minutesToTimeString(Math.floor(backgroundContextMenu.minutes / clickSnapMinutes) * clickSnapMinutes);
                  const endTime = minutesToTimeString(Math.min(Math.floor(backgroundContextMenu.minutes / clickSnapMinutes) * clickSnapMinutes + 60, 23 * 60 + 59));
                  setAbsenceModal({
                    absence: { from: `${backgroundContextMenu.date}T${startTime}:00`, to: `${backgroundContextMenu.date}T${endTime}:00`, description: '' },
                    isEdit: false,
                    professional: timeOffProfessional,
                  });
                  setBackgroundContextMenu(null);
                }}
              >
                <EventBusyIcon style={{ fontSize: '1rem', color: 'var(--text-muted)' }} />
                {t(TK.bookPersonalTime)}
              </button>
            );
          })()}
        </div>
      </>
    )}

    {absenceModal && (
      <AbsenceModal
        initialAbsence={absenceModal.absence}
        isEdit={absenceModal.isEdit}
        onClose={() => setAbsenceModal(null)}
        professionals={!absenceModal.isEdit && isAdmin ? professionalsForBranch : undefined}
        initialProfessionalId={absenceModal.professional.id}
        onSave={async (updatedAbsence, selectedProfessional) => {
          const prof = selectedProfessional ?? absenceModal.professional;
          const currentAbsences = (selectedBranch ? prof.branchAbsences?.[selectedBranch] : prof.absences) ?? [];
          const newAbsences = absenceModal.isEdit
            ? currentAbsences.map(a => a === absenceModal.absence ? updatedAbsence : a)
            : [...currentAbsences, updatedAbsence];
          const updated = selectedBranch
            ? { ...prof, branchAbsences: { ...prof.branchAbsences, [selectedBranch]: newAbsences } }
            : { ...prof, absences: newAbsences };
          if (myProfessional?.id === prof.id) {
            await updateMeProfessionalAsync(updated);
            dispatch(loadEntities('professionals', getProfessionalMeAsync, 'AppendResult'));
          } else {
            await updateProfessionalAsync(prof.id, updated);
            dispatch(loadEntities('professionals', () => getProfessionalAsync(prof.id), 'AppendResult'));
          }
          dispatch(alertSuccess(t(TK.savedSuccessfully)));
        }}
        onDelete={absenceModal.isEdit ? async () => {
          const prof = absenceModal.professional;
          const newAbsences = ((selectedBranch ? prof.branchAbsences?.[selectedBranch] : prof.absences) ?? []).filter(a => a !== absenceModal.absence);
          const updated = selectedBranch
            ? { ...prof, branchAbsences: { ...prof.branchAbsences, [selectedBranch]: newAbsences } }
            : { ...prof, absences: newAbsences };
          if (myProfessional?.id === prof.id) {
            await updateMeProfessionalAsync(updated);
            dispatch(loadEntities('professionals', getProfessionalMeAsync, 'AppendResult'));
          } else {
            await updateProfessionalAsync(prof.id, updated);
            dispatch(loadEntities('professionals', () => getProfessionalAsync(prof.id), 'AppendResult'));
          }
          dispatch(alertSuccess(t(TK.savedSuccessfully)));
        } : undefined}
      />
    )}

    <SendSurveyModal
      isOpen={sendSurveyAction.showSendSurveyModal}
      onClose={handleSendSurveyModalClose}
      onCreateForm={sendSurveyAction.redirectToCreateForm}
      onSelectedSurveyIdChanged={sendSurveyAction.setSelectedSurveyId}
      onSend={sendSurveyAction.sendSurvey}
      selectedSurveyDisabledMessage={sendSurveyAction.selectedSurveyDisabledMessage}
      selectedSurveyId={sendSurveyAction.selectedSurveyId}
      sendingSurvey={sendSurveyAction.sendingSurvey}
      surveys={sendSurveyAction.surveys}
    />

    {isAdmin && (
      <ImportAppointmentsModal
        isOpen={showImportAppointments}
        onClose={() => setShowImportAppointments(false)}
      />
    )}
    {isAdmin && (
      <DeleteAppointmentsModal
        isOpen={showDeleteAppointments}
        onClose={() => setShowDeleteAppointments(false)}
      />
    )}

    <AvailabilityCheckerModal
      isOpen={availabilityCheckerOpen}
      onClose={() => setAvailabilityCheckerOpen(false)}
      onSlotConfirmed={(data) => {
        setAvailabilityCheckerOpen(false);
        onCreateEntity('appointments', data);
      }}
      settings={settings}
      professionals={professionals}
      selectedBranch={selectedBranch}
    />
  </>);
}

export default connect()(Home);
